export default "__VITE_ASSET__CAA7yvVW__"